/*
  Eleven78 Cart Drawer Extras
  Custom element for the 10-minute cart urgency timer.
  Built as a real custom element (not an inline <script>) so it
  correctly re-initializes every time Dawn swaps in fresh cart-drawer
  HTML after an add/update/remove, same pattern Dawn itself uses for
  cart-remove-button, cart-note, and quantity-input.
*/
if (!customElements.get('cart-countdown-timer')) {
  class CartCountdownTimer extends HTMLElement {
    connectedCallback() {
      var DURATION = 600; // 10 minutes, in seconds
      var STORAGE_KEY = 'eleven78_cart_timer_start';
      var isEmpty = this.getAttribute('data-cart-empty') === 'true';

      if (isEmpty) {
        localStorage.removeItem(STORAGE_KEY);
        this.textContent = '';
        this.style.display = 'none';
        return;
      }

      this.style.display = '';

      var start = localStorage.getItem(STORAGE_KEY);
      if (!start) {
        start = Date.now();
        localStorage.setItem(STORAGE_KEY, start);
      }
      start = parseInt(start, 10);

      var self = this;
      function render() {
        var elapsed = Math.floor((Date.now() - start) / 1000);
        var remaining = DURATION - elapsed;
        if (remaining <= 0) {
          localStorage.removeItem(STORAGE_KEY);
          self.textContent = "Your cart's ready whenever you are.";
          clearInterval(self._interval);
          return;
        }
        var m = Math.floor(remaining / 60);
        var s = remaining % 60;
        var sPadded = s < 10 ? '0' + s : s;
        self.textContent = 'Your cart is saved for ' + m + ':' + sPadded;
      }

      render();
      this._interval = setInterval(render, 1000);
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }
  }

  customElements.define('cart-countdown-timer', CartCountdownTimer);
}
